<template>
  <div>
    <b-container
      class="service-item-bg"
      fluid
    >
      <b-container class="main-container content-padding-t-b-100">
        <component
          :is="serviceContext.component"
          :service="serviceContext"
        />
      </b-container>
    </b-container>
    <ScrollToTop />
    <CoverBg bg="cover-bg-page-bottom" />
  </div>
</template>

<script>
import CoverBg from '@/components/CoverBg';
import serviceItems from '@/constants/service/serviceItems';
import Paragraph from '@/components/Paragraph';
import ServiceProps from '@/components/Services/ServiceProps';
import ScrollToTop from '@/components/ScrollToTop';
import ClinicalDataManagement from '@/components/Services/Items/ClinicalDataManagement';
import MedicalWriting from '@/components/Services/Items/MedicalWriting';
import RegulatoryAffairs from '@/components/Services/Items/RegulatoryAffairs';
import StatisticalProgramming from '@/components/Services/Items/StatisticalProgramming';

export default {
  name: 'ServiceItem',
  components: {
    ScrollToTop,
    ServiceProps,
    Paragraph,
    CoverBg,
    ClinicalDataManagement,
    MedicalWriting,
    RegulatoryAffairs,
    StatisticalProgramming,
  },
  data() {
    return {

    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    serviceContext() {
      return serviceItems.find((s) => s.routeName === this.routeName);
    },
  },
};
</script>
